import { render, staticRenderFns } from "./RoxyTable.vue?vue&type=template&id=37cc6de1&"
import script from "./RoxyTable.vue?vue&type=script&lang=js&"
export * from "./RoxyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports